import { FILE_TYPE } from '@frontend/constants/file-image-types';

// Shared PDF import for Files and the layout editor picker.
export async function importPdfsToLayout(items, { destination = null, onExtracted = null } = {}) {
  if (!items.length) return;
  let selectedPdfs = items.map(item => ({...item}));
  const selectedZip = selectedPdfs.length === 1 && selectedPdfs[0].type === FILE_TYPE.ZIP
    ? selectedPdfs[0]
    : null;

  try {
    if (selectedZip) {
      const { data } = await axios.post('/file/extract-zip', {
        file_id: selectedZip.id,
        folder_id: selectedZip.parent_id,
      });
      selectedPdfs = data.pdf_files || [];
      onExtracted?.();

      if (!selectedPdfs.length) {
        throw new Error('The ZIP file does not contain any PDF files.');
      }
    }

    const isBatch = selectedPdfs.length > 1;
    const showCompanySelector = !destination && String($('#is-admin').data('value')) === '1';
    const companyData = showCompanySelector ? (await axios.get('/file/get-companies-list')).data : null;
    const companies = companyData?.companies || [];
    const activeCompanyId = companies.find(c => c.id == companyData?.active_company_id)?.id || companies[0]?.id;
    const customers = destination ? [] : (await axios.get('/customers')).data;

    const activeCompanyName = showCompanySelector
      ? (companies.find(c => c.id == activeCompanyId)?.name || '').toLowerCase()
      : $('#company_selector option:selected').text().trim().toLowerCase();
    let defaultCustomerId = null;
    if (activeCompanyName && customers) {
      let bestMatch = null;
      let smallestDiff = Infinity;
      for (let c of customers) {
        if (!c.name) continue;
        let custName = c.name.toLowerCase();
        if (custName === activeCompanyName) {
          bestMatch = c;
          break;
        }
        if (custName.includes(activeCompanyName) || activeCompanyName.includes(custName)) {
          let diff = Math.abs(custName.length - activeCompanyName.length);
          if (diff < smallestDiff) {
            smallestDiff = diff;
            bestMatch = c;
          }
        }
      }
      if (bestMatch) {
        defaultCustomerId = bestMatch.id;
      }
    }

    let companyOptions = companies.map(c => `<option value="${c.id}" ${c.id == activeCompanyId ? 'selected' : ''}>${c.name}</option>`).join('');
    let customerOptions = customers.map(c => `<option value="${c.id}" ${c.id == defaultCustomerId ? 'selected' : ''}>${c.name}</option>`).join('');
    const showPdfParserChoice = window.isProductionEnvironment !== true;

    const { value: formValues } = await Swal.fire({
      title: 'Select Destination',
      html:
        (showCompanySelector ? '<div class="form-group text-left">' +
        '<label>Company</label>' +
        '<select id="swal-company" class="form-control">' +
        (companies.length ? companyOptions : '<option value="">No companies available</option>') +
        '</select>' +
        '</div>' : '') +
        (destination ? '' : '<div class="form-group text-left">' +
        '<label>Customer</label>' +
        '<select id="swal-customer" class="form-control">' +
        (customers.length ? customerOptions : '<option value="">No customers available</option>') +
        '</select>' +
        '</div>') +
        (showPdfParserChoice ? '<div class="form-group text-left mt-3">' +
        '<label>PDF parser</label>' +
        '<select id="swal-pdf-parser" class="form-control">' +
        '<option value="make-pdf-editable-v2" selected>Editable layers (text, images, vectors)</option>' +
        '<option value="make_pdf_editable">Legacy (native tables)</option>' +
        '</select>' +
        '</div>' +
        '<div id="swal-legacy-pdf-options" style="display:none">' +
        '<div class="form-group text-left mt-3 mb-0">' +
        '<div class="custom-control custom-checkbox">' +
        '<input type="checkbox" class="custom-control-input" id="swal-use-native-tables" checked>' +
        '<label class="custom-control-label" for="swal-use-native-tables">Use native tables</label>' +
        '</div>' +
        '<div class="custom-control custom-checkbox mt-2">' +
        '<input type="checkbox" class="custom-control-input" id="swal-clean-table-backgrounds" checked>' +
        '<label class="custom-control-label" for="swal-clean-table-backgrounds">Clean table backgrounds</label>' +
        '</div>' +
        '<div class="custom-control custom-checkbox mt-2">' +
        '<input type="checkbox" class="custom-control-input" id="swal-separate-background-elements" checked>' +
        '<label class="custom-control-label" for="swal-separate-background-elements">Separate background elements</label>' +
        '</div>' +
        '</div>' +
        '</div>' : '') +
        '<div class="custom-control custom-checkbox mt-2">' +
        '<input type="checkbox" class="custom-control-input" id="swal-create-base-template">' +
        '<label class="custom-control-label" for="swal-create-base-template">Create base template</label>' +
        '</div>' +
        '<div class="custom-control custom-checkbox mt-2">' +
        '<input type="checkbox" class="custom-control-input" id="swal-notify-when-done" checked>' +
        '<label class="custom-control-label" for="swal-notify-when-done">Notify me when it\'s done</label>' +
        '</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Import PDF',
      didOpen: () => {
        const companySelect = document.getElementById('swal-company');
        const customerSelect = document.getElementById('swal-customer');
        const nativeTablesCheckbox = document.getElementById('swal-use-native-tables');
        const cleanTableBackgroundsCheckbox = document.getElementById('swal-clean-table-backgrounds');
        const parserSelect = document.getElementById('swal-pdf-parser');
        const legacyOptions = document.getElementById('swal-legacy-pdf-options');
        parserSelect?.addEventListener('change', () => {
          legacyOptions.style.display = parserSelect.value === 'make_pdf_editable' ? '' : 'none';
        });
        if (nativeTablesCheckbox && cleanTableBackgroundsCheckbox) {
          const syncCleanTableBackgrounds = () => {
            cleanTableBackgroundsCheckbox.disabled = !nativeTablesCheckbox.checked;
            if (nativeTablesCheckbox.checked) {
              cleanTableBackgroundsCheckbox.checked = true;
            } else {
              cleanTableBackgroundsCheckbox.checked = false;
            }
          };
          nativeTablesCheckbox.addEventListener('change', syncCleanTableBackgrounds);
          syncCleanTableBackgrounds();
        }
        companySelect?.addEventListener('change', () => {
          const selectedCompany = companies.find(c => c.id == companySelect.value);
          const companyName = selectedCompany?.name?.toLowerCase() || '';
          const matchedCustomer = customers.find(c => c.name?.toLowerCase() === companyName);
          if (matchedCustomer && customerSelect) {
            customerSelect.value = matchedCustomer.id;
          }
        });
      },
      preConfirm: () => {
        const companyId = document.getElementById('swal-company')?.value;
        const customerId = destination?.customer_id || document.getElementById('swal-customer')?.value;
        const parser = document.getElementById('swal-pdf-parser')?.value || 'make_pdf_editable';
        const useNativeTables = document.getElementById('swal-use-native-tables')?.checked || false;
        const cleanTableBackgrounds = useNativeTables
          && (document.getElementById('swal-clean-table-backgrounds')?.checked || false);
        if (!customerId || (showCompanySelector && !companyId)) {
          Swal.showValidationMessage(showCompanySelector
            ? 'Please select a Company and a Customer'
            : 'Please select a Customer');
          return false;
        }
        return {
          company_id: companyId,
          customer_id: customerId,
          parser,
          use_native_tables: useNativeTables,
          clean_table_backgrounds: cleanTableBackgrounds,
          separate_background_elements: document.getElementById('swal-separate-background-elements')?.checked || false,
          create_base_template: document.getElementById('swal-create-base-template')?.checked || false,
          notify_when_done: document.getElementById('swal-notify-when-done')?.checked || false,
        };
      }
    });

    if (!formValues) {
      return; // User cancelled
    }

    const totalPdfs = selectedPdfs.length;
    let completedCount = 0;
    let successCount = 0;
    let destinationUrl = null;
    const errors = [];

    const updateProgress = (percentage, message) => {
      const bar = document.getElementById('pdf-progress-bar');
      const text = document.getElementById('pdf-progress-text');
      if (!bar || !text) return;

      const overallPercentage = Math.min(99, Math.round(((completedCount + percentage / 100) / totalPdfs) * 100));
      bar.style.width = overallPercentage + '%';
      bar.setAttribute('aria-valuenow', overallPercentage);
      bar.innerHTML = overallPercentage + '%';
      text.innerHTML = totalPdfs > 1
        ? `PDF ${completedCount + 1} of ${totalPdfs}: ${message}`
        : message;
    };

    Swal.fire({
      title: isBatch ? 'Processing PDFs to Templates...' : 'Processing PDF to Template...',
      html: `
        <div id="pdf-progress-text" class="mb-2">Initializing...</div>
        <div class="progress mb-3">
          <div id="pdf-progress-bar" class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      `,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
      backdrop: true
    });

    for (const [index, selectedPdf] of selectedPdfs.entries()) {
      const taskId = `pdf_${Date.now()}_${selectedPdf.id || index}`;
      let progressInterval;

      try {
        updateProgress(0, 'Initializing...');
        progressInterval = setInterval(async () => {
          try {
            const { data: progressData } = await axios.get('/file/convert-pdf-progress?task_id=' + taskId);
            if (progressData && progressData.total) {
              const percentage = Number(progressData.percentage) || 0;
              const current = progressData.current;
              const total = progressData.total;
              updateProgress(percentage, progressData.message || `Page ${current} of ${total}`);
            }
          } catch (e) {
            // Ignore polling errors while conversion is in progress.
          }
        }, 1500);

        const payload = {
          image_url: selectedPdf.original_path || selectedPdf.path || selectedPdf.full_url,
          user_file_id: selectedPdf.id,
          company_id: formValues.company_id || undefined,
          customer_id: formValues.customer_id,
          parser: formValues.parser,
          use_native_tables: formValues.use_native_tables,
          clean_table_backgrounds: formValues.clean_table_backgrounds,
          separate_background_elements: formValues.separate_background_elements,
          create_base_template: formValues.create_base_template,
          notify_when_done: formValues.notify_when_done,
          layout_id: destination?.layout_id || null,
          task_id: taskId
        };
        const { data } = await axios.post('/file/convert-pdf-to-template', payload);

        if (data.success && data.redirect_url) {
          successCount++;
          if (destination) {
            destinationUrl = data.redirect_url;
          } else if (isBatch) {
            window.open(data.redirect_url, '_blank');
          } else {
            Swal.close();
            window.location.href = data.redirect_url;
            return;
          }
        } else {
          errors.push(data.error || `Failed to convert ${selectedPdf.name || 'PDF'}.`);
        }
      } catch (error) {
        errors.push(error.response?.data?.error || error.message || `Failed to convert ${selectedPdf.name || 'PDF'}.`);
      } finally {
        clearInterval(progressInterval);
        completedCount++;
        updateProgress(100, 'Completed');
      }
    }

    Swal.close();
    if (destinationUrl && !errors.length) {
      window.location.href = destinationUrl;
      return;
    }
    if (successCount > 0) {
      await Swal.fire({
        icon: errors.length ? 'warning' : 'success',
        title: errors.length ? 'Conversion completed with errors' : 'Conversion completed',
        text: `${successCount} PDF${successCount === 1 ? '' : 's'} made editable.${errors.length ? ` ${errors.length} failed.` : ''}`,
        showCancelButton: false,
        confirmButtonText: 'OK',
      });
      if (destinationUrl) {
        window.location.href = destinationUrl;
      }
    } else {
      await Swal.fire({
        icon: 'error',
        title: 'Conversion failed',
        text: errors[0] || 'Failed to convert PDF to Template.',
      });
    }
  } catch (error) {
    const errorMsg = error.response?.data?.error || error.message || 'An error occurred during conversion.';
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMsg,
    });
  }
}
